import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    {
        field: 'upload_id',
        headerName: 'ID',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'vendor_name',
        headerName: 'Vendor',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'file_name',
        headerName: 'File Name',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'upload_date',
        headerName: 'Upload Date',
        flex: 1,
        minWidth: 100,
        valueGetter: (uploadInfo) => {
            if(!uploadInfo.row.upload_date) return "";
            return uploadInfo.row.upload_date.substring(0, 10)
        }, 
        editable: false
    },
    {
        field: 'order_count',
        headerName: 'Order Count',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'successful',
        headerName: 'Successful',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'failed',
        headerName: 'Failed',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
    {
        field: 'user',
        headerName: 'User',
        flex: 1,
        minWidth: 75,
        editable: false
    }, 
];

function WarrantyTable(props) {

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#FAA0A0', 
                            '&:hover': {
                                backgroundColor: '#cc3333',  
                            },
                        },
                    }}
                    rows = {props.uploads}
                    getRowId = {(row) => row.upload_id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {false}
                />
            </Box>
        </Box>
    )

}

export default WarrantyTable;